import { ModalContentLayout } from 'layouts/ModalContentLayout'
import * as S from './styles'
import { DatePicker, Radio } from 'components/Form'
import { Button, DSButtonType } from 'components/Buttons'
import { useForm, Controller, SubmitHandler } from 'react-hook-form'
import { getPreviousYearDate, oneYearApart } from 'commons/utils/date'
import { Alert } from 'components/Alert'
import { ReportDowloadOptionsType } from '../Filter'
import { useEffect, useMemo } from 'react'
import { LoadingHavaianas } from 'components/Loading'
import moment from 'moment'

// TODO: Replace momentjs with dayjs

export type PeriodFormProps = {
  initialQuota: string
  finalQuota: string
}

type ModalReportProps = {
  open: boolean
  setOpen: (value: boolean) => void
  selectedOption: string
  setSelectedOption: (value: ReportDowloadOptionsType) => void
  onSubmit: SubmitHandler<PeriodFormProps>
  isLoading: boolean
}
const ModalReport = ({
  open,
  setOpen,
  selectedOption,
  setSelectedOption,
  onSubmit,
  isLoading
}: ModalReportProps) => {
  const defaultValues = {
    initialQuota: getPreviousYearDate(new Date()),
    finalQuota: new Date().toString()
  }
  const { control, handleSubmit, reset, getValues, formState, trigger } =
    useForm<PeriodFormProps>({
      mode: 'onChange',
      defaultValues
    })

  const handleClose = () => {
    reset(defaultValues)
    setSelectedOption('currentFilter')
    setOpen(false)
  }

  const isValidInterval = useMemo(() => {
    const { initialQuota, finalQuota } = getValues()
    if (formState.errors.initialQuota || formState.errors.finalQuota) return true
    return oneYearApart(new Date(initialQuota), new Date(finalQuota))
  }, [formState])

  useEffect(() => {
    if (selectedOption === 'currentFilter') reset(defaultValues)
  }, [selectedOption])

  return (
    <>
      {open && (
        <ModalContentLayout
          closeAction={handleClose}
          title="Baixar relatório"
          closeButton
          titleSize={24}
        >
          {!isLoading ? (
            <S.Content onSubmit={handleSubmit(onSubmit)}>
              <Radio
                label="Baixar resultado de busca"
                value="currentFilter"
                name="report_type"
                checked={selectedOption === 'currentFilter'}
                onChange={() => setSelectedOption('currentFilter')}
              />
              <Radio
                label="Baixar período personalizado"
                value="customPeriod"
                name="report_type"
                checked={selectedOption === 'customPeriod'}
                onChange={() => setSelectedOption('customPeriod')}
              />
              {selectedOption === 'customPeriod' && (
                <S.WrapChoosePeriod>
                  <p>Indique um período de até 1 ano.</p>
                  <S.WrapMonthInputs>
                    <Controller
                      name="initialQuota"
                      control={control}
                      rules={{
                        validate: {
                          min: (date) =>
                            moment(date)
                              .endOf('month')
                              .isAfter(moment().subtract(5, 'year').startOf('month')) ||
                            'Data inválida.'
                        }
                      }}
                      render={({ field, fieldState }) => (
                        <DatePicker
                          {...field}
                          minDate={moment().subtract(5, 'year') as unknown as string}
                          maxDate={moment().add(5, 'year') as unknown as string}
                          label="Mês cota inicial"
                          onChange={(date) => {
                            field.onChange(moment(date).format('YYYY-MM'))
                            trigger()
                          }}
                          error={fieldState.error?.message}
                          errorState={!isValidInterval}
                          views={['year', 'month']}
                          inputFormat="MM/YYYY"
                          disableMaskedInput={false}
                        />
                      )}
                    />
                    <Controller
                      name="finalQuota"
                      control={control}
                      rules={{
                        validate: {
                          min: (date) =>
                            moment(date)
                              .endOf('month')
                              .isAfter(moment().subtract(5, 'year').startOf('month')) ||
                            'Data inválida.',
                          afterBegin: (date) =>
                            moment(date)
                              .endOf('month')
                              .isAfter(
                                moment(getValues('initialQuota')).startOf('month')
                              ) || 'Período inválido.'
                        }
                      }}
                      render={({ field, fieldState }) => (
                        <DatePicker
                          {...field}
                          minDate={moment().subtract(5, 'year') as unknown as string}
                          maxDate={moment().add(5, 'year') as unknown as string}
                          label="Mês cota final"
                          onChange={(date) => {
                            field.onChange(moment(date).format('YYYY-MM'))
                            trigger()
                          }}
                          error={fieldState.error?.message}
                          errorState={!isValidInterval}
                          views={['year', 'month']}
                          inputFormat="MM/YYYY"
                          disableMaskedInput={false}
                        />
                      )}
                    />
                  </S.WrapMonthInputs>
                  {!isValidInterval && (
                    <Alert
                      title="O período deve ser inferior a 1 ano."
                      kind="error"
                      fullWidth
                    />
                  )}
                </S.WrapChoosePeriod>
              )}
              <S.WrapButtons>
                <Button
                  fullWidth={false}
                  height={37}
                  type="button"
                  content="Voltar"
                  design={DSButtonType.TEXT_BUTTON}
                  onClick={handleClose}
                />
                <Button
                  fullWidth={false}
                  height={37}
                  type="submit"
                  content="Baixar"
                  disabled={!isValidInterval || !!formState.errors?.finalQuota}
                  design={DSButtonType.SM_PRIMARY_BUTTON}
                />
              </S.WrapButtons>
            </S.Content>
          ) : (
            <LoadingHavaianas />
          )}
        </ModalContentLayout>
      )}
    </>
  )
}

export default ModalReport
